import { render, staticRenderFns } from "./credits_detail.vue?vue&type=template&id=c2b047b2&scoped=true&"
import script from "./credits_detail.vue?vue&type=script&lang=js&"
export * from "./credits_detail.vue?vue&type=script&lang=js&"
import style0 from "./credits_detail.vue?vue&type=style&index=0&id=c2b047b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b047b2",
  null
  
)

export default component.exports